var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHidOr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 29.251,
    viewBox: "0 0 22.5 29.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-hid-or",
    d: "M24.75,10.294A31.442,31.442,0,0,0,18.366,3.5a.6.6,0,0,0-.731-.007,31.057,31.057,0,0,0-6.363,6.785C8.648,13.936,6.841,17.9,6.757,22.3c0,.084-.007.176-.007.26a9.189,9.189,0,0,0,.766,3.663,9.88,9.88,0,0,0,1.069,1.849,11.607,11.607,0,0,0,9.408,4.556c6.216,0,11.257-4.507,11.257-10.069C29.25,18.077,27.352,13.964,24.75,10.294ZM18.7,28.877h-.035a.616.616,0,0,1-.183-1.2,8.754,8.754,0,0,0,6.075-5.681.612.612,0,0,1,1.181.218v.1A6.822,6.822,0,0,1,18.7,28.877Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#ff770e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHidOr);
export default __webpack_public_path__ + "static/media/icon-hid-or.dea127ec4ba2dc2235e19dac26533de0.svg";
export { ForwardRef as ReactComponent };